export default __webpack_public_path__ + "static/media/User Management.6db53e6f.svg";